import { render } from "./MaterialGallery.vue?vue&type=template&id=26c48d6a&scoped=true"
import script from "./MaterialGallery.vue?vue&type=script&lang=js"
export * from "./MaterialGallery.vue?vue&type=script&lang=js"

import "./MaterialGallery.vue?vue&type=style&index=0&id=26c48d6a&scoped=true&lang=scss"
import "./MaterialGallery.vue?vue&type=style&index=1&id=26c48d6a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26c48d6a"]])

export default __exports__